import { render } from "./TheReminder.vue?vue&type=template&id=527ac7c0&scoped=true"
import script from "./TheReminder.vue?vue&type=script&lang=js"
export * from "./TheReminder.vue?vue&type=script&lang=js"

import "./TheReminder.vue?vue&type=style&index=0&id=527ac7c0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-527ac7c0"]])

export default __exports__